import type { ActionFieldOption, ActionFieldValue } from "../ActionFieldEditor";

export interface EmailSenderMetadata {
  readonly label?: string;
  readonly email_address?: string;
  readonly connection_type?: string;
  readonly access_mode?: "workspace" | "send_only";
  readonly can_send?: boolean;
  readonly can_read?: boolean;
  readonly can_sync?: boolean;
  readonly can_autocomplete?: boolean;
  readonly can_reply?: boolean;
  readonly can_forward?: boolean;
  readonly can_schedule?: boolean;
}

export function resolveEmailSender(options: readonly ActionFieldOption[], reference?: string) {
  const option = options.find((item) => item.value === reference);
  const metadata = option?.metadata;
  const sendOnly = metadata?.access_mode === "send_only" || metadata?.connection_type === "email_send";
  const realEmail = metadata?.email_address || (reference?.includes("@") ? reference : undefined);
  return { sendOnly, realEmail, canAutocomplete: Boolean(realEmail && !sendOnly && metadata?.can_autocomplete !== false && (options.length === 0 || option)), option };
}

/** Keep the opaque selection intact and clear operations that need mailbox reads. */
export function changeEmailSender(values: Readonly<Record<string, ActionFieldValue>>, reference: string, options: readonly ActionFieldOption[]) {
  const next: Record<string, ActionFieldValue> = { ...values, from_account: reference };
  if (resolveEmailSender(options, reference).sendOnly) {
    for (const key of ["scheduled_for", "send_at"]) delete next[key];
    next.include_signature = false;
    next.provider = "gmail";
  }
  return next;
}
